export function normalizeClientPath(pathname: string): string {
  let p = pathname;
  const baseRaw = import.meta.env.BASE_URL || '/';
  const base = baseRaw.endsWith('/') ? baseRaw.slice(0, -1) : baseRaw;
  if (base && base !== '/' && p.startsWith(base)) {
    p = p.slice(base.length) || '/';
  }
  if (!p.startsWith('/')) p = `/${p}`;
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
  return p || '/';
}

export function isAnonymousEmbedBrowsePath(normalizedPath: string): boolean {
  const p = normalizedPath === '' ? '/' : normalizedPath;
  if (p === '/') return true;
  if (p === '/schedule' || p.startsWith('/schedule/')) return true;
  if (p === '/branches') return true;
  if (p.startsWith('/sessions/')) return true;
  if (p === '/services' || p.startsWith('/services/')) return true;
  if (p === '/trainers' || p.startsWith('/trainers/')) return true;
  if (p === '/about') return true;
  if (p === '/subscription-plans') return true;
  return false;
}
